// TODO: Reinstante the code below to use the cookies-next library instead once we're confident the
// siteLanguage cookie, set in the website codebase, has been overwritten for all users to exclude
//  the encoded site name, which currently breaks the call to getCookie()
function getLocaleFromCookie(): string {
	const name = 'siteLanguage='
	const cookie = document.cookie.split(';')
	for (let i = 0; i < cookie.length; i++) {
		let c = cookie[i]
		while (c.charAt(0) == ' ') {
			c = c.substring(1)
		}
		if (c.indexOf(name) == 0) {
			const language = JSON.parse(c.substring(name.length, c.length)).Language

			return language.MajorCode + '-' + language.MinorCode
		}
	}
	return 'en-GB'
}

export default getLocaleFromCookie

// import { getCookie } from 'cookies-next'

// function getLocaleFromCookie(): string {
// 	const siteLanguage = getCookie('siteLanguage')

// 	if (siteLanguage) {
// 		try {
// 			const language = JSON.parse(siteLanguage as string).Language
// 			if (language?.MajorCode && language?.MinorCode) {
// 				return `${language.MajorCode}-${language.MinorCode}`
// 			}
// 		} catch (e) {
// 			console.error('Error parsing siteLanguage cookie:', e)
// 		}
// 	}

// 	return 'en-GB'
// }

// export default getLocaleFromCookie
